/* 
    발주 내역 테스트 데이터

    1. 발주 번호(pk)
    2. 발주 일자
    3. 매장명
    4. 상품 리스트
        4-1. 상품 번호(pk)
        4-2. 상품갯수 리스트
    5. 발주 상태(accept, deliver, cancel)
    6. 매장 전화번호
*/

const testOrderData = [];

// 매장명과 발주 상태를 랜덤으로 선택하기 위한 배열
const storeNames = ["관저점", "둔산점", "탄방점", "대덕점"];
const orderStatusList = ["accept", "deliver", "cancel"];

// 랜덤 숫자를 반환하는 함수
function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

// 현재 날짜 및 시간을 가져오는 함수
function getCurrentDateTime() {
    const now = new Date();
    const year = now.getFullYear().toString().slice(-2); // 년도의 뒤 2자리만 사용
    const month = ('0' + (now.getMonth() + 1)).slice(-2); // 월을 2자리 숫자로
    const date = ('0' + now.getDate()).slice(-2); // 일을 2자리 숫자로

    return `${year}-${month}-${date}`;
}

for (let i = 1; i <= 10; i++) {
    const orderNo = i;
    const orderDate = getCurrentDateTime();
    const storeName = storeNames[getRandomNumber(0, storeNames.length - 1)];
    const productNo = [1, 2, 3];
    const productCnt = [getRandomNumber(1, 100), getRandomNumber(1, 100), getRandomNumber(1, 100)];
    const orderStatus = orderStatusList[getRandomNumber(0, orderStatusList.length - 1)];
    const storePhoneNumber = "01012341234";

    testOrderData.push({
        orderNo,
        orderDate,
        storeName,
        productNo,
        productCnt,
        orderStatus,
        storePhoneNumber
    });
}

export default testOrderData;